import { useEffect, useState } from 'react';
import { SignOutPopover } from '../../../../UI/sign-out-popover';
import { UserAvatar } from '../../../../user-avatar';
import './styles.css';
import { Tooltip } from 'flowbite-react';
import { getFilterViewDataReports, handleOpenEmail, isSafari } from '../../../../../utils';
import { NotificationsPopover } from '../../../../UI/notifications-popover';
import { Button } from '../../../../UI/button';
import {
  useAccountHasFreePlan,
  useAccountHasPlanPaid,
  useAccountHasStarterPlan,
  useAccountHasTrialPlanPaid
} from '../../../../../lib/store/dashboard.store';
import { UpgradePlanModal } from '../../../../UI/modal/upgrade-plan';
import { HeaderFileName } from './fileName/index';
import {
  useDownloadDocumentStatus,
  useFileDetails,
  useLastPageStore,
  useNavigationMenu,
  useNewLillyClaim
} from '../../../../../lib/store/v3/layout';
import {
  useAccountHasLillyPaid,
  useDownloadOptions,
  useShowDownloadPopUp
} from '../../../../../lib/store/frame.store';
import { useLocation, useNavigate } from 'react-router-dom';
import html2canvas from 'html2canvas';
import html2pdf from 'html2pdf.js';
import jsPDF from 'jspdf';
import {
  useComparisonStore,
  useFilters360Box,
  useFiltersComparisonBox
} from '../../../../../lib/store/360.store';
import {
  useAccordionUI,
  useBreakDownSelected,
  useDistributionStore,
  useViewSelected
} from '../../../../../lib/store/reports.store';
import {
  useAccordionUICluster,
  useClusterViewsData,
  useDownloadClick,
  useExclusionValues,
  usePredictiveStore
} from '../../../../../lib/store/cluster.store';
import { useUpgradeNavigation } from '../../../../../customHooks/useHasUpgrade';
import {
  useCorrelationStore,
  useCorrelationViewsData
} from '../../../../../lib/store/correlation.store';
import { Userpilot } from 'userpilot';
import { DownloadPopUp } from '../../../../UI/Accordion/content-panel/pop-up/download';

export const Header = () => {
  const location = useLocation().pathname;
  const setNavigation = useNavigationMenu((state: any) => state.setNavigation);
  const navigate = useNavigate();
  const isSafariBrowser = isSafari();
  const [openPopover, setOpenPopover] = useState<boolean>(false);
  const [openPopoverNotification, setOpenPopoverNotification] = useState<boolean>(false);
  const accountPaidDashboard = useAccountHasPlanPaid((state: any) => state.accountPaid);
  const starterAccount = useAccountHasStarterPlan((state: any) => state.accountPaid);
  const trialAccountPaid = useAccountHasTrialPlanPaid((state: any) => state.trialAccountPaid);
  const [openUpgradeModal, setOpenUpgradeModal] = useState<boolean>(false);
  const fileSelected = useFileDetails((state: any) => state.fileSelected);
  const accordionInfoCluster = useAccordionUICluster((state: any) => state.accordionData);
  const menuClusterData = useClusterViewsData((state: any) => state.viewDataSelected);
  const menuCorrelationData = useCorrelationViewsData((state: any) => state.viewDataSelected);
  const { handleUpgradeNavigation } = useUpgradeNavigation();
  const freeAccount = useAccountHasFreePlan((state: any) => state.freeAccount);
  const accountLillyPaid = useAccountHasLillyPaid((state: any) => state.accountPaid);
  const newLillyClaim = useNewLillyClaim((state: any) => state.newLillyClaim);

  /*
  Download states
  */
  const downloadOption = useDownloadOptions((state: any) => state.option);
  const setDownloadOption = useDownloadOptions((state: any) => state.setOption);
  const filters360 = useFilters360Box((state: any) => state.filters);
  const filtersComparison = useFiltersComparisonBox((state: any) => state.filters);
  const breakDownSelected = useBreakDownSelected((state: any) => state.breakDownSelected);
  const viewSelected = useViewSelected((state: any) => state.viewSelected);
  const accordionInfo = useAccordionUI((state: any) => state.accordionData);
  const setIsClickDownload = useDownloadClick((state: any) => state.setIsClick);
  const valuesExcluded = useExclusionValues((state: any) => state.valuesExcluded);
  const setShowDownloadModal = useShowDownloadPopUp((state: any) => state.setShow);
  const setDownloading = useDownloadDocumentStatus((state: any) => state.setDownloading);
  const showDownloadModal = useShowDownloadPopUp((state: any) => state.show);
  const comparisonAIChat = useComparisonStore((state) => state.comparison);
  const distributionRequestAIChat = useDistributionStore((state) => state.distribution);
  const correlationsRequestAIChat = useCorrelationStore((state) => state.correlations);
  const predictiveRequestAIChat = usePredictiveStore((state) => state.predictive);

  const handleMouseEnterAvatar = () => {
    setOpenPopover(!openPopover);
  };

  const handleMouseLeaveAvatar = () => {
    setOpenPopover(false);
  };

  const pdfReportDefaults = (doc) => {
    doc.addFont('/typo/Montserrat-Bold.ttf', 'montserrat-bold', 'bold');
    doc.addFont('/typo/Montserrat-Regular.ttf', 'montserrat-regular', 'regular');

    doc.setFont('montserrat-bold', 'bold');
    doc.setFontSize(12);
    const textWidthview = doc.getTextWidth(viewSelected);
    const textWidthBreakdown = doc.getTextWidth(`${viewSelected} by ${breakDownSelected}`);

    const pageWidth = doc.internal.pageSize.width;
    const centerViewX = (pageWidth - textWidthview) / 2;
    const centerBreakdownX = (pageWidth - textWidthBreakdown) / 2;
    if (breakDownSelected) {
      doc.text(centerBreakdownX, 30, `${viewSelected} by ${breakDownSelected}`);
    } else doc.text(centerViewX, 30, viewSelected);

    doc.setFont('montserrat-bold', 'bold');
    doc.setFontSize(8);

    if (accordionInfo && accordionInfo.length > 0) {
      let filtersText = '';
      const total = accordionInfo.length;
      accordionInfo.forEach((element, index: number) => {
        filtersText +=
          ' ' + element.parent + ': ' + element.children + (total === index + 1 ? ' \n' : ';');
      });

      const lines = doc.splitTextToSize(`Filters: ${filtersText}`, 180);
      doc.text(lines, 105, 40, null, null, 'center');
    }

    doc.setTextColor(0, 0, 255);
    doc.setTextColor(0, 0, 0);
  };

  const handleDownloadReportChart = () => {
    const setDiagram = document.getElementsByClassName('echarts-for-react')[0];
    if (!setDiagram) {
      return;
    }
    const diagram: any = document.getElementsByTagName('canvas')[0]?.parentElement;
    const diagW = diagram.offsetWidth;
    const divToPdf = document.createElement('div');

    divToPdf.appendChild(diagram);
    divToPdf.style.width = diagW + 'px';
    document.body.appendChild(divToPdf);

    html2canvas(divToPdf).then((canvas) => {
      const doc: any = new jsPDF();
      const ban = canvas.toDataURL('pdf');
      pdfReportDefaults(doc);
      doc.addImage(ban, 'pdf', 15, 60, 185, 70);
      setDiagram.appendChild(diagram);
      setIsClickDownload(false);
      setDownloading(false);
      doc.save(`Distributions.pdf`);
    });
  };

  const handleCorrelationChart = () => {
    setIsClickDownload(true);
    setTimeout(() => {
      const contentElement: any = document.getElementsByClassName('correlations-download')[0];
      const divToPdf = document.createElement('div');
      const tailwindClasses = 'correlations-download pdf-export-mode';
      divToPdf.className += '' + tailwindClasses;
      divToPdf.innerHTML = contentElement.innerHTML;
      const analysisData: any[] = [];

      const agCell = divToPdf.getElementsByClassName('ag-cell');
      Array.from(agCell).forEach((el) => {
        el.classList.add('correlation-pdf-download');
      });

      const agHeaderCell = divToPdf.getElementsByClassName('ag-header-cell-text');
      Array.from(agHeaderCell).forEach((el) => {
        el.classList.add('correlation-pdf-download');
      });

      const agHeaderCellLabel = divToPdf.getElementsByClassName('ag-header-cell-label');
      Array.from(agHeaderCellLabel).forEach((el) => {
        el.classList.add('correlation-pdf-download');
      });

      const agIconCell = divToPdf.getElementsByClassName('ag-icon');
      Array.from(agIconCell).forEach((el) => {
        el.classList.add('correlation-pdf-download');
      });

      const agHeaderCellPdf4 = divToPdf.getElementsByClassName('ag-header-cell');
      Array.from(agHeaderCellPdf4).forEach((el) => {
        el.classList.add('correlation-pdf-download');
      });

      const barChart = divToPdf.getElementsByClassName('bar-chart-pdf');
      Array.from(barChart).forEach((el) => {
        el.classList.add('correlation-pdf-download');
      });

      menuCorrelationData.forEach((element) => {
        const viewsAnalysisChecked = element.values?.filter((e) => e.checked);
        const mapAnalysis = viewsAnalysisChecked.map((e) => {
          return { ...e, view: element.view };
        });
        analysisData.push(mapAnalysis || []);
      });

      let textFilters = '';
      analysisData.forEach((element, i: number) => {
        for (let index = 0; index < element.length; index++) {
          const elementChild = element[index];
          if (index > 0) {
            elementChild.view = '';
          }
          const lastValue = index === element.length - 1 ? '' : ', ';
          textFilters += element[index].view
            ? `<b>${element[index].view}: </b>` + element[index].name + lastValue
            : '' + element[index].name + lastValue;
          if (
            analysisData.length > 1 &&
            index === element.length - 1 &&
            i < analysisData.length - 1
          ) {
            textFilters += '; ';
          }
        }
      });

      let additionalText;

      additionalText =
        '<div class="sample font-montserrat -mb-8">' +
        `<div class="text-xs text-start">File: ${fileSelected.name}</div>` +
        '<div class="sample mt-4 mb-16 flex flex-row justify-start ml-12 font-montserrat">' +
        '<div class="flex flex-row justify-start items-center ">' +
        '<span class="font-bold text-xs underline decoration-light-black text-start text-light-black">Correlations:</span>' +
        `<div class='text-xs font-normal text-center ml-2'>${textFilters}</div>` +
        '</div>' +
        '</div>' +
        '</div>';

      divToPdf.insertAdjacentHTML('afterbegin', additionalText);

      const opt = {
        margin: 0.3,
        pagebreak: { mode: 'avoid-all' },
        filename: `Correlations.pdf`,
        image: { type: 'jpeg', quality: 0.99 },
        html2canvas: {
          width: 1200,
          windowWidth: 1200,
          scale: 2,
          dpi: 192,
          ignoreElements: (el) => el.classList.contains('hide-component')
        },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
      };

      const htmlToPDf = async () => {
        await html2pdf().set(opt).from(divToPdf).toPdf().save();
        setTimeout(() => {
          setIsClickDownload(false);
          setDownloading(false);
          setShowDownloadModal(false);
          if (document.body.contains(divToPdf)) {
            document.body.removeChild(divToPdf);
          }
          const addedTextElement = contentElement.getElementsByClassName('sample')[0];
          if (addedTextElement) {
            addedTextElement.remove();
          }
        }, 1000);
      };

      htmlToPDf();
    }, 500);
  };

  const handleDownloadPredictiveChart = () => {
    setIsClickDownload(true);
    setTimeout(() => {
      const contentElement: any = document.getElementsByClassName('predictive-download')[0];
      const divToPdf = document.createElement('div');
      const tailwindClasses = 'predictive-download pdf-export-mode';
      divToPdf.className += '' + tailwindClasses;
      divToPdf.innerHTML = contentElement.innerHTML;
      const analysisData: any[] = [];

      const pdfElements = divToPdf.getElementsByClassName('predictive-model-tittle');
      Array.from(pdfElements).forEach((el) => {
        el.classList.add('pdf-export-active');
      });

      const pdfTotalElements = divToPdf.getElementsByClassName('total-label');
      Array.from(pdfTotalElements).forEach((el) => {
        el.classList.add('pdf-export-active');
      });

      const pdfTopElements = divToPdf.getElementsByClassName('mt-minus');
      Array.from(pdfTopElements).forEach((el) => {
        el.classList.add('pdf-export-active');
      });

      const pdfValueElements = divToPdf.getElementsByClassName('values-margin');
      Array.from(pdfValueElements).forEach((el) => {
        el.classList.add('pdf-export-active');
      });

      const pdfPredictiveHeadersElements = divToPdf.getElementsByClassName('predictive-headers');
      Array.from(pdfPredictiveHeadersElements).forEach((el) => {
        el.classList.add('pdf-export-active');
      });

      const pdfPredictivePtcElements = divToPdf.getElementsByClassName('predictive-pct');
      Array.from(pdfPredictivePtcElements).forEach((el) => {
        el.classList.add('pdf-export-active');
      });

      const pdfPredictivePointIconElements =
        divToPdf.getElementsByClassName('predictive-point-icon');
      Array.from(pdfPredictivePointIconElements).forEach((el) => {
        el.classList.add('pdf-export-active');
      });

      const pdfPredictiveStatsElements = divToPdf.getElementsByClassName('predictive-stats');
      Array.from(pdfPredictiveStatsElements).forEach((el) => {
        el.classList.add('pdf-export-active');
      });

      const pdfPredictiveTopNuklElements = divToPdf.getElementsByClassName('predictive-top-null');
      Array.from(pdfPredictiveTopNuklElements).forEach((el) => {
        el.classList.add('pdf-export-active');
      });

      menuClusterData.forEach((element) => {
        const viewsAnalysisChecked = element.values?.filter((e) => e.checked);
        const mapAnalysis = viewsAnalysisChecked.map((e) => {
          return { ...e, view: element.view };
        });
        analysisData.push(mapAnalysis || []);
      });

      let textFilters = '';
      analysisData.forEach((element, i: number) => {
        for (let index = 0; index < element.length; index++) {
          const elementChild = element[index];
          if (index > 0) {
            elementChild.view = '';
          }
          const lastValue = index === element.length - 1 ? '' : ', ';
          textFilters += element[index].view
            ? `<b>${element[index].view}: </b>` + element[index].name + lastValue
            : '' + element[index].name + lastValue;
          if (
            analysisData.length > 1 &&
            index === element.length - 1 &&
            i < analysisData.length - 1
          ) {
            textFilters += '; ';
          }
        }
      });

      let additionalText;

      if (valuesExcluded && valuesExcluded.length > 0) {
        additionalText =
          '<div class="sample font-montserrat -mb-8">' +
          `<div class="text-xs text-start">File: ${fileSelected.name}</div>` +
          '<div class="sample mt-4 mb-16 flex flex-col gap-2 justify-start ml-12 font-montserrat">' +
          '<div class="flex flex-row justify-start items-center ">' +
          '<span class="font-bold text-xs underline decoration-light-black text-start text-light-black">Predict:</span>' +
          `<div class='text-xs font-normal text-center ml-2'>${textFilters}</div>` +
          '</div>' +
          '<div class="flex flex-row justify-start items-center ">' +
          '<span class="font-bold text-xs underline decoration-light-black text-start text-light-black">Excluded Signals:</span>' +
          `<div class='text-xs font-semibold text-center ml-2'>${valuesExcluded
            .map((e) => e.column)
            .join(', ')}</div>` +
          '</div>' +
          '</div>' +
          '</div>';
      } else {
        additionalText =
          '<div class="sample font-montserrat -mb-8">' +
          `<div class="text-xs text-start">File: ${fileSelected.name}</div>` +
          '<div class="sample mt-4 mb-16 flex flex-row justify-start ml-12 font-montserrat">' +
          '<div class="flex flex-row justify-start items-center ">' +
          '<span class="font-bold text-xs underline decoration-light-black text-start text-light-black">Predict:</span>' +
          `<div class='text-xs font-normal text-center ml-2'>${textFilters}</div>` +
          '</div>' +
          '</div>' +
          '</div>';
      }

      divToPdf.insertAdjacentHTML('afterbegin', additionalText);

      const opt = {
        margin: 0.3,
        pagebreak: { mode: 'avoid-all' },
        filename: `Predictive.pdf`,
        image: { type: 'jpeg', quality: 0.99 },
        html2canvas: {
          scale: 2,
          dpi: 192,
          ignoreElements: (el) => el.classList.contains('hide-component')
        },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
      };

      const htmlToPDf = async () => {
        await html2pdf().set(opt).from(divToPdf).toPdf().save();
        setTimeout(() => {
          setIsClickDownload(false);
          setDownloading(false);
          setShowDownloadModal(false);
          if (document.body.contains(divToPdf)) {
            document.body.removeChild(divToPdf);
          }
          const addedTextElement = contentElement.getElementsByClassName('sample')[0];
          if (addedTextElement) {
            addedTextElement.remove();
          }
        }, 1000);
      };

      htmlToPDf();
    }, 500);
  };

  const handleDownload360Chart = () => {
    setIsClickDownload(true);

    setTimeout(() => {
      const contentElement: any = document.getElementsByClassName('cohort-groups')[0];
      const divToPdf = document.createElement('div');
      const tailwindClasses = 'cohort-groups pdf-export-mode';
      divToPdf.className += '' + tailwindClasses;
      divToPdf.innerHTML = contentElement.innerHTML;

      const pdfElements = divToPdf.getElementsByClassName('group-view');
      Array.from(pdfElements).forEach((el) => {
        el.classList.add('pdf-export-active');
      });

      const pdfElementItems = divToPdf.getElementsByClassName('group-item');
      Array.from(pdfElementItems).forEach((el) => {
        el.classList.add('pdf-export-active');
      });

      const pdfElementAnalysisComp = divToPdf.getElementsByClassName('group-analysis-comparison');
      Array.from(pdfElementAnalysisComp).forEach((el) => {
        el.classList.add('pdf-export-active');
      });

      const pdfElementGroupComp = divToPdf.getElementsByClassName('group-view-comp');
      Array.from(pdfElementGroupComp).forEach((el) => {
        el.classList.add('pdf-export-active');
      });

      const pdfElementHeight = divToPdf.getElementsByClassName('group-height');
      Array.from(pdfElementHeight).forEach((el) => {
        el.classList.add('pdf-export-active');
      });

      const analysisData: any[] = [];
      const comparisonData: any[] = [];
      filters360.forEach((element) => {
        const viewsAnalysisChecked = element.values?.filter((e) => e.analyzeChecked);
        const mapAnalysis = viewsAnalysisChecked.map((e) => {
          return { ...e, view: element.view };
        });
        analysisData.push(mapAnalysis || []);
      });
      filtersComparison.forEach((element) => {
        const viewsCompareChecked = element.values?.filter((e) => e.compareChecked);
        const mapComparison = viewsCompareChecked.map((e) => {
          return { ...e, view: element.view };
        });
        comparisonData.push(mapComparison || []);
      });

      let textAnalysisFilters = '';
      let textComparisonFilters = '';
      analysisData.forEach((element, i: number) => {
        for (let index = 0; index < element.length; index++) {
          const elementChild = element[index];
          if (index > 0) {
            elementChild.view = '';
          }
          const lastValue = index === element.length - 1 ? '' : ', ';
          textAnalysisFilters += element[index].view
            ? `<b>${element[index].view}: </b>` + element[index].name + lastValue
            : '' + element[index].name + lastValue;
          if (
            analysisData.length > 1 &&
            index === element.length - 1 &&
            i < analysisData.length - 1
          ) {
            textAnalysisFilters += '; ';
          }
        }
      });

      comparisonData.forEach((element, i: number) => {
        for (let index = 0; index < element.length; index++) {
          const elementChild = element[index];
          if (index > 0) {
            elementChild.view = '';
          }
          const lastValue = index === element.length - 1 ? '' : ', ';
          textComparisonFilters += element[index].view
            ? `<b>${element[index].view}: </b>` + element[index].name + lastValue
            : '' + element[index].name + lastValue;
          if (
            comparisonData.length > 1 &&
            index === element.length - 1 &&
            i < comparisonData.length - 1
          ) {
            textComparisonFilters += '; ';
          }
        }
      });
      let additionalText;
      if (textComparisonFilters && textComparisonFilters.length > 0) {
        additionalText =
          '<div class="sample font-montserrat -mb-16">' +
          `<div class="text-xs text-start">File: ${fileSelected.name}</div>` +
          '<div class="pl-3 mt-4 mb-16 flex flex-row gap-3.5 justify-center font-montserrat">' +
          '<div class="flex flex-col max-w-[312px] min-w-[260px]">' +
          '<span class="font-bold text-xs underline decoration-[#FD8F22] underline-offset-8 text-center text-[#FD8F22]">Analysis Group</span>' +
          `<div class='text-[10px] font-normal text-center'>${textAnalysisFilters}</div>` +
          '</div>' +
          '<div class="flex flex-col max-w-[312px] min-w-[260px]">' +
          '<span class="font-bold text-xs underline decoration-[#2497B2] underline-offset-8 text-center text-[#2497B2]">Comparison Group</span>' +
          `<div class='text-[10px] font-normal text-center'>${textComparisonFilters}</div>` +
          '</div>' +
          '</div>' +
          '</div>';
      } else {
        additionalText =
          '<div class="sample font-montserrat -mb-16">' +
          `<div class="text-xs text-start">File: ${fileSelected.name}</div>` +
          '<div class="sample mt-4 mb-16 flex flex-row justify-center font-montserrat">' +
          '<div class="flex flex-col max-w-[312px]">' +
          '<span class="font-bold text-xs underline decoration-[#FD8F22] text-center text-[#FD8F22]">Analysis Group</span>' +
          `<div class='text-[10px] font-normal text-center'>${textAnalysisFilters}</div>` +
          '</div>' +
          '</div>' +
          '</div>';
      }
      divToPdf.insertAdjacentHTML('afterbegin', additionalText);
      const opt = {
        margin: 0.3,
        // pagebreak: { mode: 'avoid-all' },
        filename: `Comparative.pdf`,
        image: { type: 'jpeg', quality: 0.99 },
        // html2canvas: { scale: 2 },
        html2canvas: {
          scale: 2,
          dpi: 192,
          ignoreElements: (el) => el.classList.contains('hide-button')
        },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
      };

      const htmlToPDf = async () => {
        await html2pdf().set(opt).from(divToPdf).toPdf().save();
        setTimeout(() => {
          setIsClickDownload(false);
          setDownloading(false);
          setShowDownloadModal(false);
          if (document.body.contains(divToPdf)) {
            document.body.removeChild(divToPdf);
          }
          const addedTextElement = contentElement.getElementsByClassName('sample')[0];
          if (addedTextElement) {
            addedTextElement.remove();
          }
        }, 1000);
      };

      htmlToPDf();
    }, 500);
  };

  useEffect(() => {
    const isComparative = location.includes('comparative');
    const isDistributions = location.includes('distributions');
    const isPredictive = location.includes('predictive');
    const isCorrelations = location.includes('correlations');
    if (downloadOption && downloadOption?.length > 0) {
      if (isDistributions && downloadOption === 'pdf') {
        handleDownloadReportChart();
      } else if (isComparative && downloadOption === 'pdf') {
        handleDownload360Chart();
      } else if (isPredictive && downloadOption === 'pdf') {
        handleDownloadPredictiveChart();
      } else if (isCorrelations && downloadOption === 'pdf') {
        handleCorrelationChart();
      }
      if (downloadOption === 'pdf') setDownloadOption('');
    }
  }, [downloadOption]);

  const invalidPages =
    location.includes('files') ||
    location.includes('new_file') ||
    location.includes('connectors') ||
    location.includes('faqs');

  return (
    <>
      {(comparisonAIChat && comparisonAIChat?.filters?.length > 0) ||
      (distributionRequestAIChat && distributionRequestAIChat?.fields?.length > 0) ||
      (correlationsRequestAIChat && correlationsRequestAIChat?.filters?.length > 0) ||
      (predictiveRequestAIChat && Object.keys(predictiveRequestAIChat?.target).length > 0) ? (
        <></>
      ) : (
        <>
          <header onMouseLeave={handleMouseLeaveAvatar}>
            <nav className="bg-[#F5F5F580] border-b-[1px] w-full h-[60px]">
              <div className="flex justify-between">
                <div className={`${invalidPages ? 'invisible' : ''} flex items-center`}>
                  {isSafariBrowser ? (
                    <div className="absolute pl-8 max-w-[30%] md:max-w-[24.5%]">
                      <HeaderFileName file={fileSelected?.name || ''} />
                    </div>
                  ) : (
                    <div className="absolute pl-8 max-w-[30%] md:max-w-[24.5%]">
                      {fileSelected?.name && fileSelected?.name?.length > 39 ? (
                        <Tooltip
                          arrow={true}
                          content={fileSelected?.name || ''}
                          style="light"
                          placement="bottom-end"
                          animation="duration-500"
                          className="w-auto border-gray-300 rounded-lg px-4 text-xs text-[#364152] font-montserrat mb-20">
                          <HeaderFileName file={fileSelected?.name || ''} />
                        </Tooltip>
                      ) : (
                        <HeaderFileName file={fileSelected?.name || ''} />
                      )}
                    </div>
                  )}
                </div>
                <div className="flex justify-end pt-0.5">
                  {(accountPaidDashboard || starterAccount || trialAccountPaid || freeAccount) &&
                    !accountLillyPaid &&
                    !newLillyClaim && (
                      <div className="pt-[11px] pr-5">
                        <Button
                          textColor="#E7811D"
                          description="Upgrade"
                          backgroundColor="#C1F4FF80"
                          fontSize={12}
                          fontWeight={600}
                          heigh={32}
                          borderSize="2px"
                          border={5}
                          width={103}
                          handleClick={() => {
                            Userpilot.track('upgrade_button');
                            setNavigation('upgrade');
                            navigate('/upgrade');
                          }}
                          className="outline-none max-w-[103px]"
                          borderColor="#1C8CA699"
                          icon="/icons/rocket-colorful.png"
                          iconDirection="right"
                          descriptionClass=""
                          iconClass="h-[26px]"
                        />
                      </div>
                    )}

                  <div className="flex items-center align-middle gap-[22px]">
                    <img src="/icons/vertical-line.svg" className="" alt="Vertical Line" />
                    <UserAvatar handleMouseEnter={handleMouseEnterAvatar} />
                  </div>
                </div>
              </div>

              {openPopover && (
                <SignOutPopover
                  from="dashboard"
                  openPopover={openPopover}
                  setOpenPopover={setOpenPopover}
                />
              )}
            </nav>
          </header>
        </>
      )}

      {openPopoverNotification && (
        <NotificationsPopover
          openPopover={openPopoverNotification}
          setOpenPopover={setOpenPopoverNotification}
          from="dashboard"
        />
      )}

      {openUpgradeModal && (
        <UpgradePlanModal
          openModal={openUpgradeModal}
          setOpenModal={setOpenUpgradeModal}
          hasLogo={true}
          text=""
        />
      )}
    </>
  );
};
